"use client";
/*
 * Documentation:
 * Tooltip — https://app.subframe.com/d960199b9abf/library?component=Tooltip_ccebd1e9-f6ac-4737-8376-0dfacd90c9f3
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface TooltipRootProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

const TooltipRoot = React.forwardRef<HTMLDivElement, TooltipRootProps>(
  function TooltipRoot(
    { children, className, ...otherProps }: TooltipRootProps,
    ref
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          "flex flex-col items-start rounded-md border border-solid border-neutral-900 bg-neutral-800 px-1.5 py-0.5 shadow-lg",
          className
        )}
        ref={ref}
        {...otherProps}
      >
        {children ? (
          <span className="text-[11px] leading-[1.35] font-caption text-black">
            {children}
          </span>
        ) : null}
      </div>
    );
  }
);

export const Tooltip = TooltipRoot;
